import React, {Component} from 'react'
import TimeLineCheckPoint from './TimeLineCheckPoint'

class CustomerDetailsTimeLine extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: false,

    }


  }


  onClick() {
    console.log('clicked')

    if (this.state.selected === false) {
      this.setState({selected: true})
    } else {
      this.setState({selected: false})
    }
  }


  buildTimeLine() {

    let returnCheckpoints = []
    let checkpoints = this.props.checkpoints

    let lastDay = ''

    for (let i = checkpoints.length - 1; i >= 0; i--) {

      if (i === checkpoints.length - 1) {
        let day = '';

        if (this.props.carrier == null) {
          day = new Date(checkpoints[i].timestamp)
        } else {
          day = new Date(checkpoints[i].timestamp)
        }
        // 2009-11-10
        let month = day.toLocaleString('default', {month: 'short'})
        let formatDay = day.getDate() + ' ' + month + ' ' + day.getFullYear()
        lastDay = formatDay


        returnCheckpoints.push(
            <div key={i} className="timeline-section-day-top">
              <div>
                <div className="timeline-day">
                  {formatDay}
                </div>
              </div>
            </div>,
        )

        let selected = false
        if (i == checkpoints.length - 1) {
          selected = true
        }

        returnCheckpoints.push(
            <TimeLineCheckPoint key={i + 'c'} selected={selected} carrier={this.props.carrier} item={checkpoints[i]}/>,
        )


      } else {
        let day
        day = new Date(checkpoints[i].timestamp)
        let month = day.toLocaleString('default', {month: 'short'})
        let formatDay = day.getDate() + ' ' + month + ' ' + day.getFullYear()
        if (formatDay !== lastDay) {
          lastDay = formatDay

          returnCheckpoints.push(
              <div key={i} className="timeline-section-day">
                <div className="timeline-day">
                  {formatDay}
                </div>
              </div>,
          )
        }
        let selected = false
        if (i == checkpoints.length - 1) {
          selected = true
        }
        returnCheckpoints.push(
            <TimeLineCheckPoint key={i + 'c'} selected={selected} carrier={this.props.carrier} item={checkpoints[i]}/>,
        )
      }
    }
    return returnCheckpoints

  }

  render() {
    let timeLineContent = this.buildTimeLine()
    return (
        <div style={{marginBottom: '10px'}}>

          <div className='CDT-TimeLineContainer'>

            <div style={{paddingBottom: '5px'}}>
              <div className="CDT-TimeLineInnerContainer">
                <div className="timeline">
                  {timeLineContent}

                </div>
              </div>
            </div>

          </div>
        </div>


    )
  }
}

export default CustomerDetailsTimeLine
